import type { NewStaticAlarm, StaticAlarm } from '@/models/types/alarm/static-alarm'
import type { AllarmeStaticoDTO, NuovoAllarmeStaticoDTO } from '@/models/dto/allarme/allarme-statico-dto'
import { mapToNewAlarm, mapToNuovoAllarmeDTO } from './alarm-mapper'

const mapToStaticAlarm = (dto: AllarmeStaticoDTO): StaticAlarm => {
    return { ...mapToNewStaticAlarm(dto), id: dto.id }
}

const mapToAllarmeStaticoDTO = (alarm: StaticAlarm): AllarmeStaticoDTO => {
    return { ...mapToNuovoAllarmeStaticoDTO(alarm), id: alarm.id }
}

const mapToNewStaticAlarm = (dto: NuovoAllarmeStaticoDTO): NewStaticAlarm => {
    return {
        ...mapToNewAlarm(dto),
        rMaxThreshold: dto.rMaxThreshold,
        rMinThreshold: dto.rMinThreshold,
        value: dto.value,
    }
}

const mapToNuovoAllarmeStaticoDTO = (alarm: NewStaticAlarm): NuovoAllarmeStaticoDTO => {
    return {
        ...mapToNuovoAllarmeDTO(alarm),
        rMaxThreshold: alarm.rMaxThreshold,
        rMinThreshold: alarm.rMinThreshold,
        value: alarm.value,
    }
}

export { mapToAllarmeStaticoDTO, mapToNewStaticAlarm, mapToNuovoAllarmeStaticoDTO, mapToStaticAlarm }
